import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Sidebar from "../../components/sidebar/Sidebar";
import jsPDF from "jspdf";

import {
  PageLayout,
  Container,
  Header,
  Title,
  Subtitle,
  Table,
  TableRow,
  TableHeader,
  TableCell,
  SearchWrapper,
  SearchInput,
  SortWrapper
} from "./styles";

import { Search, FileText, BarChart3 } from "lucide-react";

const Relatorios = () => {

  const [usuarios, setUsuarios] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [oportunidades, setOportunidades] = useState([]);

  const [query, setQuery] = useState("");
  const [sortType, setSortType] = useState("az");

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchData = async () => {

      try {

        const resUsuarios = await api.get("/api/users");
        const resEventos = await api.get("/api/content/eventos");
        const resCursos = await api.get("/api/content/cursos");
        const resOportunidades = await api.get("/api/content/oportunidades");

        setUsuarios(
  Array.isArray(resUsuarios.data)
    ? resUsuarios.data
    : resUsuarios.data.users || []
);
        setEventos(Array.isArray(resEventos.data) ? resEventos.data : []);
        setCursos(Array.isArray(resCursos.data) ? resCursos.data : []);
        setOportunidades(Array.isArray(resOportunidades.data) ? resOportunidades.data : []);

      } catch (error) {
        console.error("Erro ao carregar relatórios", error);
      }

      setLoading(false);

    };

    fetchData();

  }, []);

  /* =====================
     RELATÓRIO GERAL
  ===================== */

  const totalUsuarios = Array.isArray(usuarios) ? usuarios.length : 0;
  const totalEventos = eventos.length;
  const totalCursos = cursos.length;
  const totalOportunidades = oportunidades.length;

  /* =====================
     FUNÇÕES DE MÉTRICAS
  ===================== */

  const inscritosEvento = (id) =>
    usuarios.filter(u => u.eventosInscritos?.includes(id)).length;

  const checkinsEvento = (id) =>
    usuarios.reduce((acc, user) => {

      const checkins =
        user.historicoCheckins?.filter(
          c => c.tipo === "Evento" && String(c.refId) === String(id)
        ) || [];

      return acc + checkins.length;

    }, 0);

  const likesEvento = (id) =>
    usuarios.filter(u => u.likes?.eventos?.includes(id)).length;

  const inscritosCurso = (id) =>
    usuarios.filter(u => u.cursosInscritos?.includes(id)).length;

  const likesCurso = (id) =>
    usuarios.filter(u => u.likes?.cursos?.includes(id)).length;

  const likesOportunidade = (id) =>
    usuarios.filter(u => u.likes?.oportunidades?.includes(id)).length;

  /* =====================
     JUNTA TODAS PUBLICAÇÕES
  ===================== */

  const publicacoes = [

    ...eventos.map(evento => ({
      id: evento._id,
      titulo: evento.titulo,
      tipo: "Evento",
      inscritos: inscritosEvento(evento._id),
      checkins: checkinsEvento(evento._id),
      likes: likesEvento(evento._id)
    })),

    ...cursos.map(curso => ({
      id: curso._id,
      titulo: curso.titulo,
      tipo: "Curso",
      inscritos: inscritosCurso(curso._id),
      checkins: "-",
      likes: likesCurso(curso._id)
    })),

    ...oportunidades.map(o => ({
      id: o._id,
      titulo: o.titulo,
      tipo: "Oportunidade",
      inscritos: "-",
      checkins: "-",
      likes: likesOportunidade(o._id)
    }))

  ];

  /* =====================
     PESQUISA
  ===================== */

  const filtered = publicacoes.filter(pub =>
    pub.titulo.toLowerCase().includes(query.toLowerCase())
  );

  /* =====================
     ORDENAÇÃO
  ===================== */

  const sortPublicacoes = (list) => {

    const copy = [...list];

    if (sortType === "az") {
      copy.sort((a, b) => a.titulo.localeCompare(b.titulo));
    }

    if (sortType === "za") {
      copy.sort((a, b) => b.titulo.localeCompare(a.titulo));
    }

    if (sortType === "likes") {
      copy.sort((a, b) => b.likes - a.likes);
    }

    return copy;
  };

  const displayed = sortPublicacoes(filtered);

  if (loading) {
    return (
      <PageLayout>
        <Sidebar />
        <Container>
          <p>Carregando relatórios...</p>
        </Container>
      </PageLayout>
    );
  }

 const gerarRelatorio = () => {

  const pdf = new jsPDF();

  const dataGeracao = new Date().toLocaleDateString("pt-BR");

  /* métricas */

  const totalInscritosEventos = eventos.reduce(
    (acc, e) => acc + inscritosEvento(e._id),
    0
  );

  const totalInscritosCursos = cursos.reduce(
    (acc, c) => acc + inscritosCurso(c._id),
    0
  );

  const totalCheckins = eventos.reduce(
    (acc, e) => acc + checkinsEvento(e._id),
    0
  );

  const totalLikesEventos = eventos.reduce(
    (acc, e) => acc + likesEvento(e._id),
    0
  );

  const totalLikesCursos = cursos.reduce(
    (acc, c) => acc + likesCurso(c._id),
    0
  );

  const totalLikesOportunidades = oportunidades.reduce(
    (acc, o) => acc + likesOportunidade(o._id),
    0
  );

  /* ===== TÍTULO ===== */

  pdf.setFontSize(20);
  pdf.text("Relatório Geral da Plataforma", 20, 20);

  pdf.setFontSize(10);
  pdf.text(`Data de geração: ${dataGeracao}`, 20, 28);

  /* ===== RESUMO ===== */

  pdf.setFontSize(14);
  pdf.text("Resumo Geral", 20, 45);

  pdf.setFontSize(11);

  pdf.text(`Total de usuários: ${usuarios.length}`, 20, 55);
  pdf.text(`Total de eventos: ${eventos.length}`, 20, 63);
  pdf.text(`Total de cursos: ${cursos.length}`, 20, 71);
  pdf.text(`Total de oportunidades: ${oportunidades.length}`, 20, 79);

  pdf.text(`Inscrições em eventos: ${totalInscritosEventos}`, 110, 55);
  pdf.text(`Inscrições em cursos: ${totalInscritosCursos}`, 110, 63);
  pdf.text(`Check-ins em eventos: ${totalCheckins}`, 110, 71);

  pdf.text(`Likes em eventos: ${totalLikesEventos}`, 20, 95);
  pdf.text(`Likes em cursos: ${totalLikesCursos}`, 20, 103);
  pdf.text(`Likes em oportunidades: ${totalLikesOportunidades}`, 20, 111);

  /* ===== TABELA DE PUBLICAÇÕES ===== */

  pdf.setFontSize(14);
  pdf.text("Publicações", 20, 130);

  let y = 140;

  pdf.setFontSize(11);
  pdf.text("Título", 20, y);
  pdf.text("Tipo", 100, y);
  pdf.text("Inscritos", 130, y);
  pdf.text("Likes", 165, y);

  y += 8;

  displayed.forEach(pub => {

    if (y > 280) {
      pdf.addPage();
      y = 20;
    }

    pdf.text(pub.titulo.substring(0, 40), 20, y);
    pdf.text(pub.tipo, 100, y);
    pdf.text(String(pub.inscritos), 130, y);
    pdf.text(String(pub.likes), 165, y);

    y += 8;

  });

  pdf.save("relatorio-plataforma.pdf");

};

const gerarRelatorioPublicacao = async (pub) => {
  try {
    let endpoint = "";

    if (pub.tipo === "Evento") {
      endpoint = `/api/content/eventos/${pub.id}`;
    }

    if (pub.tipo === "Curso") {
      endpoint = `/api/content/cursos/${pub.id}`;
    }

    if (pub.tipo === "Oportunidade") {
      endpoint = `/api/content/oportunidades/${pub.id}`;
    }

    const res = await api.get(endpoint);
    const data = res.data;

    const pdf = new jsPDF();
    const dataGeracao = new Date().toLocaleString("pt-BR");

    let y = 20;

    pdf.setFontSize(20);
    pdf.text("Relatório Detalhado da Publicação", 20, y);

    y += 10;

    pdf.setFontSize(10);
    pdf.text(`Gerado em: ${dataGeracao}`, 20, y);

    y += 15;

    /* =====================
       INFORMAÇÕES GERAIS
    ===================== */

    pdf.setFontSize(14);
    pdf.text("Informações Gerais", 20, y);

    y += 10;
    pdf.setFontSize(11);

    pdf.text(`Título: ${data.titulo || "-"}`, 20, y);
    y += 8;

    pdf.text(`Tipo: ${pub.tipo}`, 20, y);
    y += 8;

    if (data.descricao) {
      const desc = pdf.splitTextToSize(data.descricao, 170);
      pdf.text("Descrição:", 20, y);
      y += 6;
      pdf.text(desc, 20, y);
      y += desc.length * 6;
    }

    y += 6;

    if (data.organizador) {
      pdf.text(`Organizador: ${data.organizador}`, 20, y);
      y += 8;
    }

    if (data.organizacao) {
      pdf.text(`Organização: ${data.organizacao}`, 20, y);
      y += 8;
    }

    if (data.empresa) {
      pdf.text(`Empresa: ${data.empresa}`, 20, y);
      y += 8;
    }

    if (data.cargo) {
      pdf.text(`Cargo: ${data.cargo}`, 20, y);
      y += 8;
    }

    /* =====================
       DATAS
    ===================== */

    pdf.setFontSize(14);
    pdf.text("Datas", 20, y);

    y += 10;
    pdf.setFontSize(11);

    if (data.data) {
      pdf.text(`Data: ${new Date(data.data).toLocaleDateString("pt-BR")}`, 20, y);
      y += 8;
    }

    if (data.dataInicio) {
      pdf.text(
        `Data início: ${new Date(data.dataInicio).toLocaleDateString("pt-BR")}`,
        20,
        y
      );
      y += 8;
    }

    if (data.dataFim) {
      pdf.text(
        `Data fim: ${new Date(data.dataFim).toLocaleDateString("pt-BR")}`,
        20,
        y
      );
      y += 8;
    }

    if (data.hora) {
      pdf.text(`Hora: ${data.hora}`, 20, y);
      y += 8;
    }

    /* =====================
       LOCAL / STATUS
    ===================== */

    pdf.setFontSize(14);
    pdf.text("Local e Status", 20, y);

    y += 10;
    pdf.setFontSize(11);

    if (data.local) {
      pdf.text(`Local: ${data.local}`, 20, y);
      y += 8;
    }

    if (data.status) {
      pdf.text(`Status: ${data.status}`, 20, y);
      y += 8;
    }

    if (data.acesso) {
      pdf.text(`Acesso: ${data.acesso}`, 20, y);
      y += 8;
    }

    /* =====================
       VAGAS
    ===================== */

    pdf.setFontSize(14);
    pdf.text("Vagas", 20, y);

    y += 10;
    pdf.setFontSize(11);

    if (data.vagas !== undefined) {
      pdf.text(`Vagas disponíveis: ${data.vagas ?? "Ilimitadas"}`, 20, y);
      y += 8;
    }

    if (data.vagasOcupadas !== undefined) {
      pdf.text(`Vagas ocupadas: ${data.vagasOcupadas}`, 20, y);
      y += 8;
    }

    /* =====================
       ENGAJAMENTO
    ===================== */

    pdf.setFontSize(14);
    pdf.text("Engajamento", 20, y);

    y += 10;
    pdf.setFontSize(11);

    pdf.text(`Likes: ${data.likes || 0}`, 20, y);
    y += 8;

    if (data.xp !== undefined) {
      pdf.text(`XP oferecido: ${data.xp}`, 20, y);
      y += 8;
    }

    /* =====================
       TAGS
    ===================== */

    if (data.tags && data.tags.length > 0) {
      pdf.setFontSize(14);
      pdf.text("Tags", 20, y);

      y += 10;
      pdf.setFontSize(11);

      pdf.text(data.tags.join(", "), 20, y);
      y += 10;
    }

    /* =====================
       CONTEÚDOS
    ===================== */

    if (data.conteudos && data.conteudos.length > 0) {
      pdf.setFontSize(14);
      pdf.text("Conteúdos", 20, y);

      y += 10;

      data.conteudos.forEach((c) => {
        pdf.setFontSize(12);
        pdf.text(c.titulo || "Conteúdo", 20, y);

        y += 8;

        c.itens.forEach((item) => {
          pdf.setFontSize(11);
          pdf.text(`• ${item}`, 25, y);
          y += 6;
        });

        y += 4;
      });
    }

    /* =====================
       CONTATOS
    ===================== */

    if (data.contatos && data.contatos.length > 0) {
      pdf.setFontSize(14);
      pdf.text("Contatos", 20, y);

      y += 10;

      data.contatos.forEach((c) => {
        if (c.telefone) {
          pdf.text(`Telefone: ${c.telefone}`, 20, y);
          y += 8;
        }

        if (c.email) {
          pdf.text(`Email: ${c.email}`, 20, y);
          y += 8;
        }

        if (c.redeSocial) {
          pdf.text(`Rede social: ${c.redeSocial}`, 20, y);
          y += 8;
        }
      });
    }

    /* =====================
       DATA DE CRIAÇÃO
    ===================== */

    if (data.criadoEm) {
      pdf.setFontSize(10);
      pdf.text(
        `Criado em: ${new Date(data.criadoEm).toLocaleDateString("pt-BR")}`,
        20,
        280
      );
    }

    pdf.save(`relatorio-${data.titulo}.pdf`);
  } catch (error) {
    console.error("Erro ao gerar relatório", error);
    alert("Erro ao gerar relatório");
  }
};

  return (

    <PageLayout>

      <Sidebar />

      <Container>

        <Header>
          <div>
            <Title>Relatórios</Title>
            <Subtitle>Estatísticas da plataforma</Subtitle>
          </div>
        </Header>

        {/* RELATÓRIO GERAL */}

        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem"
  }}
>
  <Title style={{ fontSize: "22px" }}>
    Relatório Geral mensal
  </Title>

  <button
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      padding: "8px 12px",
      borderRadius: 6,
      border: "1px solid #e5e7eb",
      background: "#fff",
      cursor: "pointer",
      fontWeight: 500
    }}
    onClick={gerarRelatorio}
  >
    <FileText size={18} />
    Gerar relatório detalhado
  </button>
</div>

        <Table>
          <thead>
            <TableRow>
              <TableHeader>Usuários</TableHeader>
              <TableHeader>Eventos</TableHeader>
              <TableHeader>Cursos</TableHeader>
              <TableHeader>Oportunidades</TableHeader>
            </TableRow>
          </thead>

          <tbody>
            <TableRow>
              <TableCell>{totalUsuarios}</TableCell>
              <TableCell>{totalEventos}</TableCell>
              <TableCell>{totalCursos}</TableCell>
              <TableCell>{totalOportunidades}</TableCell>
            </TableRow>
          </tbody>
        </Table>

        {/* PUBLICAÇÕES */}

        <Title style={{ fontSize: "22px", marginTop: "2rem" }}>
          Publicações
        </Title>

        <SortWrapper>
          <label>Ordenar por:</label>

          <select
            value={sortType}
            onChange={(e) => setSortType(e.target.value)}
          >
            <option value="az">A–Z</option>
            <option value="za">Z–A</option>
            <option value="likes">Mais curtidos</option>
          </select>
        </SortWrapper>

        <SearchWrapper>
          <Search size={18} />

          <SearchInput
            placeholder="Pesquisar publicações..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </SearchWrapper>

        <Table>

          <thead>
            <TableRow>
              <TableHeader>Título</TableHeader>
              <TableHeader>Tipo</TableHeader>
              <TableHeader>Inscritos</TableHeader>
              <TableHeader>Check-ins</TableHeader>
              <TableHeader>Likes</TableHeader>
              <TableHeader>Relatório</TableHeader>
            </TableRow>
          </thead>

          <tbody>

  {displayed.map(pub => (

    <TableRow key={pub.id}>

      <TableCell>{pub.titulo}</TableCell>

      <TableCell>{pub.tipo}</TableCell>

      <TableCell>{pub.inscritos}</TableCell>

      <TableCell>{pub.checkins}</TableCell>

      <TableCell>{pub.likes}</TableCell>

      <TableCell
  style={{
    textAlign: "center"
  }}
>
  <button
  style={{
    border: "none",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto"
  }}
  onClick={() => gerarRelatorioPublicacao(pub)}
>
  <FileText size={18} />
</button>
</TableCell>

    </TableRow>

  ))}

</tbody>

        </Table>

      </Container>

    </PageLayout>

  );

};

export default Relatorios;